<template>
  <div class="d-flex flex-column a-pricing-strategy-apply-strategy py-1">
    <div v-if="showInput" class="d-flex align-center" style="gap: 5px">
      <template v-if="suggestion.status !== 'ignored'">
        <v-checkbox
          v-if="showCheckbox"
          v-model="selected"
          value="selected"
          color="secondary"
          on-icon="mdi-checkbox-marked"
          off-icon="mdi-checkbox-blank"
          class="ma-0 pa-0 mr-n2"
          hide-details
          dense
        />
        <v-spacer />
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :loading="loading"
              class="main-btn ignore-btn"
              x-small
              depressed
              rounded
              @click="ignoreSuggestion"
            >
              <v-icon color="red" size="14">
                mdi-eye-off-outline
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Ignore") }}</span>
        </v-tooltip>
        <v-text-field
          v-model="pricing_strategy_value"
          type="number"
          background-color="white"
          class="input-suggestion"
          hide-details
          dense
          solo
          flat
          @input="selected = 'selected'"
        >
          <template v-slot:append>
            <span class="symbol caption font-weight-bold">
              €
            </span>
          </template>
        </v-text-field>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :loading="loading"
              color="secondary"
              class="main-btn send-btn"
              x-small
              depressed
              @click="applySuggestion"
            >
              <v-icon size="12">
                mdi-send-outline
              </v-icon>
              <!-- <v-icon size="16">
                mdi-chevron-double-right
              </v-icon> -->
            </v-btn>
          </template>
          <span>{{ $t("Send") }}</span>
        </v-tooltip>
      </template>
      <template v-else>
        <a-kpi
          kpi="price"
          :value="suggestion.price_suggestion"
          absolute
          xx_small
        ></a-kpi>
        <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              v-bind="attrs"
              v-on="on"
              :loading="loading"
              color="green"
              icon
              small
              style="opacity: 1"
              @click="reactivateSuggestion"
            >
              <v-icon size="14">
                mdi-reload
              </v-icon>
            </v-btn>
          </template>
          <span>{{ $t("Reactivate") }}</span>
        </v-tooltip>
      </template>
    </div>
    <div
      v-if="currentState === 'accepted' && !hideAcceptedSuggestion"
      class="d-flex align-center secondary--text suggestion-accepted"
      style="gap: 5px"
    >
      <!-- <v-icon color="secondary" size="18">mdi-check</v-icon> -->
      <span
        class="text-left"
        style="text-transform: none; line-height: 1; white-space: nowrap"
      >
        {{ $t("accepted_suggestion") }}
      </span>
      <span class="text-caption font-weight-bold">
        {{ suggestionCurrentFormattedPrice }}
      </span>
    </div>

    <!-- Chips -->
    <v-tooltip v-if="showExtra && density === 'default'" bottom>
      <template v-slot:activator="{ on, attrs }">
        <div
          v-bind="attrs"
          v-on="on"
          class="d-flex flex-wrap justify-end"
          style="gap: 5px"
        >
          <v-tooltip
            v-model="showTooltip"
            content-class="tooltip-shadow"
            color="white"
            min-width="500px"
            :open-on-hover="false"
            :open-on-click="false"
            bottom
          >
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-click-outside="onClickOutside"
                class="suggestion-wrapper d-flex align-center justify-space-between cursor-pointer white--text"
                :class="suggestionWrapperClass"
                style="gap: 3px;"
                @click="toggleTooltip"
              >
                <div
                  class="text-caption font-weight-bold d-flex align-center chip"
                >
                  <v-icon size="10">
                    {{ chipIcon }}
                  </v-icon>
                </div>
                <div>{{ differenceFormatted }}€</div>
              </div>
            </template>
            <div @click.stop>
              <a-pricing-strategy-recommendation-tooltip
                :suggestion="suggestion"
              />
            </div>
          </v-tooltip>
        </div>
      </template>
      <span>{{ $t("View_detailed_recommendation") }}</span>
    </v-tooltip>

    <!-- Caso 3: Usuario modificó precio y hay sugerencia (price_initial != price_current != price_suggestion) -->
    <template v-if="showModified && currentState === 'modified'">
      <div>
        <div
          class="d-inline-flex align-center secondary rounded white--text pa-2 text-left suggestion-modified"
          style="gap: 3px; text-transform: none; line-height: 1"
        >
          <span>{{ $t("user_modified_price") }}</span>
          <a-kpi
            kpi="price"
            :value="suggestion.price_current"
            absolute
            xx_small
          ></a-kpi>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import aPricingStrategyRecommendationTooltip from "@/components/pricing-strategy/aPricingStrategyRecommendationTooltip";
import aKpi from "@/components/rms_ui/aKpi";
import * as Utils from "@/utils.js";
import { mapGetters } from "vuex";
var numeral = require("numeral");

export default {
  name: "a-pricing-strategy-apply-strategy",
  components: {
    aKpi,
    aPricingStrategyRecommendationTooltip
  },
  props: {
    suggestion: {
      type: Object,
      required: true
    },
    date: {
      type: String,
      default: null
    },
    hideChip: {
      type: Boolean,
      default: false
    },
    hideInput: {
      type: Boolean,
      default: false
    },
    hideAcceptedSuggestion: {
      type: Boolean,
      default: false
    },
    showModified: {
      type: Boolean,
      default: false
    },
    showCheckbox: {
      type: Boolean,
      default: false
    },
    density: {
      type: String,
      default: "default"
    }
  },
  data: () => ({
    pricing_strategy_value: null,
    loading: false,
    showTooltip: false,
    selected: false
  }),
  watch: {
    selected(newVal) {
      this.$emit("suggestion-selection-changed", {
        suggestion: this.suggestion,
        price: this.pricing_strategy_value,
        price_current: this.suggestion.price_current,
        date: this.date,
        selected: newVal
      });
    },
    pricing_strategy_value(newVal) {
      if (this.selected) {
        this.$emit("suggestion-selection-changed", {
          suggestion: this.suggestion,
          price: newVal,
          price_current: this.suggestion.price_current,
          date: this.date,
          selected: this.selected
        });
      }
    }
  },
  computed: {
    // Casos basados en comparación de precios
    isSuggestionAccepted() {
      return this.suggestion.price_current === this.suggestion.price_suggestion;
    },
    isPriceUnchanged() {
      return this.suggestion.price_initial === this.suggestion.price_current;
    },
    isUserModifiedPrice() {
      return (
        this.suggestion.price_initial !== this.suggestion.price_current &&
        this.suggestion.price_current !== this.suggestion.price_suggestion
      );
    },
    // Estado actual basado en los casos
    currentState() {
      if (this.isSuggestionAccepted) {
        return "accepted";
      } else if (this.isPriceUnchanged) {
        return "pending";
      } else if (this.isUserModifiedPrice) {
        return "modified";
      }
      return "pending";
    },
    suggestionCurrentFormattedPrice() {
      return (
        numeral(this.suggestion.price_current).format(this.l.number0_format) +
        this.l.money_post_symbol
      );
    },
    showExtra() {
      return (
        !this.hideChip &&
        (this.currentState === "pending" || this.currentState === "modified")
      );
    },
    showInput() {
      return (
        (this.currentState === "pending" || this.currentState === "modified") &&
        !this.hideInput
      );
    },
    differenceFormatted() {
      const difference = this.suggestion.suggestion;
      if (difference > 0) {
        return "+" + difference;
      }
      return difference;
    },
    differenceColor() {
      if (this.suggestion.suggestion > 0) {
        return "green--text green-bg";
      }
      return "red--text red-bg";
    },
    suggestionWrapperClass() {
      let classes = [];
      if (this.showCheckbox) {
        classes.push("show-checkbox");
      }
      classes.push(this.differenceColor);
      return classes;
    },
    // Un solo icono: el del tipo de regla si hay una única sugerencia,
    // el genérico de recomendación si hay varias (el detalle va en el tooltip)
    chipIcon() {
      const suggestions = this.suggestion.suggestions || [];
      if (suggestions.length === 1) {
        return this.getSuggestionIcon(suggestions[0]);
      }
      return "mdi-lightbulb-on-outline";
    },
    ...mapGetters({
      current_hotel: "current_hotel",
      getPricingStrategyStrategyRatePlanById:
        "getPricingStrategyStrategyRatePlanById",
      getPricingStrategyRuleTypeByCode: "getPricingStrategyRuleTypeByCode",
      l: "current_hotel_language"
    })
  },
  methods: {
    intensifyColor(color) {
      return Utils.intensifyColor(color);
    },
    getRatePlanCode(rate_plan_id) {
      const ratePlan = this.getPricingStrategyStrategyRatePlanById(
        rate_plan_id
      );
      return ratePlan ? ratePlan.code : "N/A";
    },
    getSuggestionIcon(sug) {
      const ruleType = this.getPricingStrategyRuleTypeByCode(
        sug.rule_type_code
      );
      return (ruleType && ruleType.icon) || "mdi-lightbulb-on-outline";
    },
    toggleTooltip() {
      this.showTooltip = !this.showTooltip;
    },
    onClickOutside(e) {
      // El detalle de una regla se abre en un diálogo que vive fuera de este
      // tooltip, así que cualquier clic dentro de él cuenta como "fuera" y
      // cerraba el detalle del día. Al volver, el usuario había perdido dónde
      // estaba: mientras el diálogo esté abierto, este tooltip se queda.
      if (this.$store.state.pricingstrategy.rule_definition_info_dialog) {
        return;
      }
      // El clic que CIERRA el diálogo llega aquí después de que ya se haya
      // marcado como cerrado, así que el flag de arriba no lo cubre: hay que
      // reconocer también los clics que salen de dentro del diálogo.
      if (e && e.target && e.target.closest && e.target.closest(".v-dialog")) {
        return;
      }
      if (this.showTooltip) {
        this.showTooltip = false;
      }
    },
    applySuggestion() {
      this.loading = true;
      this.$store.dispatch("setSnackbar", {
        title: this.$t("applying_price_suggestion"),
        color: "secondary"
      });
      const data = {
        hotel_id: this.current_hotel.id,
        suggestions: [
          {
            id: this.suggestion.id,
            price: this.pricing_strategy_value
          }
        ]
      };
      this.$store
        .dispatch("applyPricingStrategySuggestions", data)
        .then(() => {
          this.loading = false;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("price_suggestion_applied"),
            color: "accent"
          });
          this.$store.dispatch("setReloadSubscribedModules");
        })
        .catch(error => {
          // console.log(error);
          this.loading = false;
          Utils.showError(this, "price_suggestion_not_applied");
        });
    },
    ignoreSuggestion() {
      this.loading = true;
      this.$store.dispatch("setSnackbar", {
        title: this.$t("ignoring_price_suggestion"),
        color: "secondary"
      });
      const data = {
        hotel_id: this.current_hotel.id,
        suggestions: [{ id: this.suggestion.id }]
      };
      this.$store
        .dispatch("ignorePricingStrategySuggestion", data)
        .then(() => {
          this.loading = false;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("price_suggestion_ignored"),
            color: "accent"
          });
        })
        .catch(error => {
          this.loading = false;
          Utils.showError(this, "price_suggestion_not_ignored");
        });
    },
    reactivateSuggestion() {
      this.loading = true;
      this.$store.dispatch("setSnackbar", {
        title: this.$t("reactivating_price_suggestion"),
        color: "secondary"
      });
      const data = {
        hotel_id: this.current_hotel.id,
        suggestions: [{ id: this.suggestion.id }]
      };
      this.$store
        .dispatch("reactivatePricingStrategySuggestion", data)
        .then(() => {
          this.loading = false;
          this.$store.dispatch("setSnackbar", {
            title: this.$t("price_suggestion_reactivated"),
            color: "accent"
          });
        })
        .catch(error => {
          this.loading = false;
          Utils.showError(this, "price_suggestion_not_reactivated");
        });
    }
  },
  mounted() {
    this.pricing_strategy_value = this.suggestion.price_suggestion;
  }
};
</script>

<style scoped lang="scss">
.a-pricing-strategy-apply-strategy {
  .input-suggestion {
    flex: 0;
    border-radius: 4px 0 0 0;
    ::v-deep .v-input__control {
      display: inline-flex !important;
      min-height: auto !important;
      .v-input__slot {
        min-height: auto !important;
        padding: 0 3px 0 5px !important;
        input {
          line-height: 1 !important;
          font-size: 13px !important;
          font-weight: 600 !important;
          padding: 2px 0 !important;
          text-align: right;
          width: 25px;
        }
        /* Para navegadores WebKit (Chrome, Safari, Edge) */
        input[type="number"]::-webkit-outer-spin-button,
        input[type="number"]::-webkit-inner-spin-button {
          -webkit-appearance: none;
          margin: 0;
        }
        /* Para Firefox */
        input[type="number"] {
          -moz-appearance: textfield;
        }
        .v-input__append-inner {
          margin: 0 0 0 0 !important;
          padding: 0 !important;
          .symbol {
            font-size: 10px !important;
            margin-left: 1px;
          }
        }
      }
    }
  }
  .btns-wrap {
    gap: 2px;
    .v-btn {
      padding: 3px;
      min-width: auto;
      height: auto;
      margin-top: 0px;
      .v-icon {
        font-size: 10px !important;
      }
    }
  }
  .suggestion-wrapper {
    border-radius: 0 0 4px 4px;
    line-height: 1;
    font-size: 9px;
    font-weight: 500;
    margin-right: 18px;
    padding: 2px 3px;
    width: 40px;
    &.green-bg {
      background-color: #dde7e4 !important;
    }
    &.red-bg {
      background-color: #ffcdd2 !important;
    }
    .chip {
      margin-left: -4px;
      ::v-deep .v-icon {
        color: inherit !important;
      }
      &:first-child {
        margin-left: 0;
      }
    }
  }
  .mini-label {
    font-size: 10px;
  }
  .suggestion-modified {
    font-size: 11px;
    line-height: 1.2 !important;
    padding: 3px 4px !important;
    white-space: nowrap;
  }
  .suggestion-accepted {
    font-size: 10px;
    white-space: normal;
  }
  .v-input--checkbox {
    ::v-deep .v-input--selection-controls__input {
      margin: 0 !important;
      height: auto;
      width: 22px;
      .v-icon {
        font-size: 14px !important;
        &.mdi-checkbox-blank {
          color: #e2e2e2 !important;
        }
      }
      .v-input--selection-controls__ripple {
        width: 17px;
        height: 17px;
        left: 0;
        top: -2px;
        margin: 0;
      }
    }
  }
  .main-btn {
    height: 100%;
    min-width: auto;
    padding: 3.5px 3px 4px;
    /* padding: 1.5px 1px 2px; */
    transition: background-color 0.1s ease;
    &.send-btn {
      background-color: #e2e2e2 !important;
      margin-left: -5px;
      border-radius: 0 4px 4px 0;
      &:hover {
        background-color: #1576c7 !important;
      }
    }
    &.ignore-btn {
      background-color: transparent !important;
      padding: 0 !important;
      .v-icon {
        color: #e2e2e2 !important;
      }
      &:hover {
        .v-icon {
          color: #e64d3c !important;
        }
        &::before {
          opacity: 0 !important;
        }
      }
    }
  }
}
</style>
